import { lazy, Suspense } from "react";
import { Card, CardContent } from "@/components/ui/card";

// Lazy load the form to reduce initial bundle size
const LazyQuickQuoteForm = lazy(() => import("./LazyQuickQuoteForm"));

const FormFallback = () => (
  <Card className="max-w-2xl mx-auto bg-white/10 backdrop-blur border-white/20">
    <CardContent className="p-6">
      <h3 className="text-xl font-semibold mb-4 text-white">Get Your Quote</h3>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 h-10 bg-white/20 rounded animate-pulse"></div>
        <div className="w-32 h-10 bg-white/20 rounded animate-pulse"></div>
        <div className="h-10 w-32 bg-gold/50 rounded animate-pulse"></div>
      </div>
    </CardContent>
  </Card>
);

export const HeroQuickForm = () => {
  return (
    <Suspense fallback={<FormFallback />}>
      <LazyQuickQuoteForm />
    </Suspense>
  );
};